import { render } from "./PaginationFooter.vue?vue&type=template&id=05a3a105&ts=true"
import script from "./PaginationFooter.vue?vue&type=script&lang=ts"
export * from "./PaginationFooter.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__